import React from "react";

const TermsOfService = () => {
    return (
        <div className="max-w-3xl mx-auto p-6 bg-white shadow-md rounded-md my-10">
            <h1 className="text-3xl font-bold text-blue-800 mb-4">Terms of Service</h1>
            <p>
                These Terms of Service (“Terms”, “Agreement”) govern your access to and
                use of Teechaa’s website, mobile applications, and related services
                operated by Teechaa Technologies Limited (“Teechaa”, “we”, “us”, “our”).
            </p>

            <h2 className="text-2xl font-semibold text-blue-700 mt-6 mb-2">1. Company Information</h2>
            <p>
                Teechaa Technologies Limited is a company incorporated under the laws of
                the Federal Republic of Nigeria, with its principal office in Gbagada,
                Lagos, Nigeria. Contact us at{" "}
                <a href="mailto:support@TeeChaa.com">support@TeeChaa.com</a>.
            </p>

            <h2 className="text-2xl font-semibold text-blue-700 mt-6 mb-2">2. Acceptance of Terms</h2>
            <p>
                By using or subscribing to Teechaa, you agree to these Terms. If you do
                not agree, please discontinue use immediately.
            </p>

            <h2 className="text-2xl font-semibold text-blue-700 mt-6 mb-2">3. Description of Service</h2>
            <p>
                Teechaa provides AI-enhanced educational services that improve
                individual students’ learning experiences through interactive tools,
                analytics, and subscription-based learning modules.
            </p>

            <h2 className="text-2xl font-semibold text-blue-700 mt-6 mb-2">4. Account Registration</h2>
            <p>
                Users must register with accurate, up-to-date information. You are
                responsible for maintaining confidentiality of your login credentials.
                Any suspicious or unauthorised account activity must be reported to{" "}
                <a href="mailto:support@TeeChaa.com">support@TeeChaa.com</a>.
            </p>

            <h2 className="text-2xl font-semibold text-blue-700 mt-6 mb-2">5. Subscriptions and Payments</h2>
            <p>
                Teechaa offers monthly and yearly subscription plans. All payments must
                be made through authorised channels. Users may upload payment receipts
                as proof of payment. Payments are non-refundable except as required by
                Nigerian law or under exceptional circumstances as determined by
                Teechaa.
            </p>

            <h2 className="text-2xl font-semibold text-blue-700 mt-6 mb-2">6. User Responsibilities</h2>
            <p>You agree to use Teechaa only for lawful educational purposes. You may not:</p>
            <ul className="list-disc ml-6">
                <li>Attempt to access restricted areas without authorisation</li>
                <li>Interfere with system operations</li>
                <li>Use Teechaa for unlawful or fraudulent purposes</li>
                <li>Copy or redistribute platform materials without written consent</li>
            </ul>

            <h2 className="text-2xl font-semibold text-blue-700 mt-6 mb-2">7. Intellectual Property</h2>
            <p>
                All materials, software, designs, and trademarks on Teechaa are owned
                or licensed by Teechaa Technologies Limited. You are granted a limited,
                non-transferable licence to use them solely for personal educational purposes.
            </p>

            <h2 className="text-2xl font-semibold text-blue-700 mt-6 mb-2">8. Limitation of Liability</h2>
            <p>
                Teechaa shall not be liable for indirect, incidental, or consequential
                damages arising from the use of our platform. Our total liability shall
                not exceed the total subscription fees paid by you in the previous
                twelve (12) months.
            </p>

            <h2 className="text-2xl font-semibold text-blue-700 mt-6 mb-2">9. Termination</h2>
            <p>
                Teechaa may suspend or terminate access to any account found in breach
                of these Terms. Upon termination, your right to access Teechaa
                immediately ceases.
            </p>

            <h2 className="text-2xl font-semibold text-blue-700 mt-6 mb-2">10. Governing Law</h2>
            <p>
                These Terms are governed by the laws of the Federal Republic of Nigeria.
                Disputes shall be settled in the courts of Lagos State, Nigeria.
            </p>
        </div>
    );
};

export default TermsOfService;
